import { configService } from '@/settings/api-url'
import store from '@/store/store';
const actions = {
  async action_getCity ({ commit, dispatch, state }, payload) {
    try {
      const res = await configService(`/cities_new/${payload}`)
      if(store.getters.getIsToken) {
        await dispatch('action_changeUserCommerce', {
          normal_user: {
            commerce_id: payload
          }
        });
      }
      const { data } = res
      commit('CITY', data)
      commit('CATEGORIES', data.products_list)
      return data;
    } catch (error) {
      return error.response
    }
  },
  action_getCityByParsedName({ state }, parsedName) {
    if(parsedName && parsedName.length) {
      const res = state.citiesRaw.find((item) => item.parsedName === parsedName);
      return res;
    }
  },
  async action_getCurrentProduct({ commit, state }, payload) {
    try {
      const res = await configService(`/commerces/${payload.idc}/products/${payload.idp}`)
      const { data } = res
      commit('CURRENT_PRODUCT', data)
      return res
    } catch (error) {
      return error.response
    }
  },
  async action_registerViewProduct({ dispatch}, id) {
    try {
      const res = await configService(`/view_product/${id}`, {
        method: 'POST'
      })
      dispatch('action_autoLogin')

    } catch (error) {
      return error.response
    }
  },
  async action_getCategories ({ getters, commit, state }, idCategory) {
    const res = await configService(`/normal_user/commerces/${getters.getCity.id}/super_categories/${idCategory}/`)
    if(res) {
      let categories = res.data.categories.sort((a, b) => a.ordinal - b.ordinal)
      categories = categories.filter((element) => {
        return element.is_active && !element.is_deleted
      })

      for (let categorie of categories) {
        categorie.products = categorie.products.filter((element) => {
          return !element.is_deleted
        })
      }

      commit('CATEGORIES', categories)
      return categories
    }
  },
  async action_getProductsSuggestions({ commit }, payload) {
    try {
      const res = await configService(
        `public/commerces/${payload.cityId}/search_preview?search=${payload.searchValue}`
      );
      if(res.data && res.data.length) {
        commit('PRODUCTS_SUGGESTIONS', res.data);
      }
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getProductsSearch({ commit }, payload) {
    try {
      const res = await configService(
        `public/commerces/${payload.cityId}/search?search=${payload.searchValue}`
      );
      commit('PRODUCTS_SEARCH', res.data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getProductRecommendations({ commit }, payload) {
    try {
      const res = await configService(`/products/${payload}/recommendations`);
      commit('PRODUCT_RECOMMENDATIONS', res.data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getCategoryById({ commit }, payload) {
    try {
      const res = await configService(`/normal_user/categories/${payload}`);
      if (res && res.data) {
        return res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_postItemNotification({ dispatch}, payload) {
    try {
      const res = await configService(`/commerces/${payload.idc}/products/${payload.idp}/register_activation`, {
        method: 'POST'
      })
      dispatch('action_autoLogin')
      return res.data

    } catch (error) {
      return error.response
    }
  }
}

export default actions
